import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import { store } from "./redux/store"
import "./i18n"
import Navigation from "./Navigation/Navigation"
import "./styles/global.css"
import AppInitializer from "./Components/AppInitializer/AppInitializer"


function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <AppInitializer>
          <Navigation />
        </AppInitializer>
      </BrowserRouter>
    </Provider>
  )
}

export default App
